
export interface BillInterface {
    id?: string;
    document?: string;
    purchase?: string;
    internalBusiness?: string;
    publicId?: string;
    displayId?: string;
    name?: string;
    email?: string;
    phone?: string;
    nif?: string;
    address?: string;
    postalCode?: string;
    town?: string;
}

export class Bill implements BillInterface {
    public id?: string;
    public document?: string;
    public purchase?: string;
    public internalBusiness?: string;
    public publicId?: string;
    public displayId?: string;
    public name?: string;
    public email?: string;
    public phone?: string;
    public nif?: string;
    public address?: string;
    public postalCode?: string;
    public town?: string;

    constructor() {
        this.id = '';
        this.name = '';
        this.email = '';
        this.phone = '';
        this.nif = '';
        this.address = '';
        this.postalCode = '';
        this.town = '';
    }
}
